"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Gcs = /*#__PURE__*/ _interop_require_default(require("./Gcs"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GcsPlugin = class GcsPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return GcsPlugin.storageAdapter;
    }
    async init(config) {
        GcsPlugin.storageAdapter = new _Gcs.default(config);
        await GcsPlugin.storageAdapter.init();
    }
};
const _default = GcsPlugin;
